import { useAddressHistory } from "modules/AddressHistory/api";
import { useWorkOrder } from "./use-work-order";
import { useCustomerProducts } from "modules/CustomerProducts/api";
import { useWorkOrderHistory } from "modules/WorkOrderHistory/api";
export const useWorkOrderPage = (workOrderId) => {
    const { workOrder, isFetching: isWorkOrderFetching, workOrderErrorMessage } = useWorkOrder(workOrderId);
    const customerId = workOrder === null || workOrder === void 0 ? void 0 : workOrder.customer.customerId;
    const addressHistoryQuery = useAddressHistory(false, workOrderId, undefined);
    const workOrderHistoryQuery = useWorkOrderHistory(workOrderId);
    const customerProductsQuery = useCustomerProducts(customerId);
    return {
        workOrder,
        addressHistory: addressHistoryQuery.addressHistory,
        customerProducts: customerProductsQuery.customerProducts,
        isLoading: isWorkOrderFetching ||
            addressHistoryQuery.isAddressHistoryLoading ||
            workOrderHistoryQuery.isWorkOrderHistoryLoading ||
            customerProductsQuery.isCustomerProductsLoading,
        workOrderErrorMessage,
        addressHistoryError: addressHistoryQuery.addressHistoryError,
        workOrderHistoryError: workOrderHistoryQuery.workOrderHistoryError,
        customerProductsErrorMessage: customerProductsQuery.customerProductsErrorMessage,
    };
};
